<template>
  <div class="relative w-full">
    <div
      class="relative w-full cursor-pointer rounded border border-solid bg-gray-100 py-[5px] pl-2 pr-8 text-sm"
      :class="
        !!isError
          ? 'border-[1.5px] border-red-400'
          : 'border-gray-600 hover:text-blue-500 focus:border-blue-400'
      "
    >
      <div ref="buttonRef" @click="toggleFold">
        <div
          class="font-bold"
          :class="isDisabled ? 'text-gray-500' : 'text-blue-400'"
        >
          {{ title }}
        </div>
        <IconCaret
          :direction="!isFold ? 'up' : 'down'"
          class="absolute right-1 top-1 h-6 w-6 text-blue-400"
        />
      </div>
    </div>
    <div
      v-if="!isFold && !isDisabled"
      ref="dropdownRef"
      class="absolute left-0 top-[36px] z-50 max-h-[200px] w-full overflow-y-auto rounded border border-solid border-gray-400 bg-gray-100 py-1 drop-shadow-lg"
    >
      <ul>
        <li v-for="item in options" :key="item.code">
          <label
            :for="item.code"
            class="my-1 inline-flex w-full cursor-pointer items-center px-2 hover:bg-gray-200"
          >
            <input
              :id="item.code"
              v-model="model"
              type="checkbox"
              class="mr-2 cursor-pointer"
              :value="item.code"
            />
            <span class="text-sm">
              {{ item.name }}
            </span>
          </label>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { onClickOutside } from '@vueuse/core';

  interface IOption {
    name: string;
    code: string;
  }

  interface IProps {
    id: string;
    title: string;
    isDisabled?: boolean;
    isError?: boolean;
    options: IOption[];
  }

  const props = withDefaults(defineProps<IProps>(), {
    isDisabled: false,
    isError: false,
  });

  const emits = defineEmits<{
    (e: 'closed', value: boolean): void;
  }>();

  const model = defineModel<string[]>({ default: () => [] });

  const isFold = ref<boolean>(true);
  const dropdownRef = ref<HTMLElement | null>(null);
  const buttonRef = ref<HTMLElement | null>(null);

  onClickOutside(
    dropdownRef,
    () => {
      isFold.value = true;
      emits('closed', true);
    },
    { ignore: [buttonRef] }
  );

  const toggleFold = (): void => {
    if (props.isDisabled) {
      return;
    }
    isFold.value = !isFold.value;
    emits('closed', isFold.value);
  };
</script>
